import toast from 'react-hot-toast';
import getErrorOptions from '../utils/getErrorOptions';
import parseMessage from '../utils/parseMessage';

const error = (message, options) =>
  toast.error(parseMessage(message), getErrorOptions(options));

export default error;
